import { useTranslation } from "react-i18next";

import { CUSTOM_CONFIRM_TYPES, CustomConfirm } from "components";
import { useEmptyKeyLockerBoxMutation } from "modules/KeyLockersDashboard/components/KeyLockerBoxesModal/hooks";
import "modules/KeyLockersDashboard/components/KeyLockerBoxesModal/KeyLockerBoxesModal.scss";

type EmptyKeyLockerBoxModalProps = {
  id: number | null;
  resetKeyLockerBoxId: () => void;
};

export const EmptyKeyLockerBoxModal = ({ id, resetKeyLockerBoxId }: EmptyKeyLockerBoxModalProps) => {
  const { t } = useTranslation();

  const { mutateAsync: emptyKeyLockerBox, isPending: isEmptyKeyLockerBoxPending } = useEmptyKeyLockerBoxMutation();

  const handleEmptyKeyLockerBox = async () => {
    if (!id) return;
    await emptyKeyLockerBox(id);
    resetKeyLockerBoxId();
  };

  return (
    <CustomConfirm
      type={CUSTOM_CONFIRM_TYPES.Danger}
      isOpen={Boolean(id)}
      handleCancel={resetKeyLockerBoxId}
      customTitle={t("v8_are_you_sure", "Are you sure?")}
      confirmMsg={t(
        "v8_this_will_empty_this_locker_box_and_allow_another_customer_to_use_it",
        "This will empty this locker box and allow another customer to use it. Make sure it was emptied. You can't undo this action, are you sure ?"
      )}
      handleConfirm={handleEmptyKeyLockerBox}
      isLoading={isEmptyKeyLockerBoxPending}
    />
  );
};
